import React, { useState, useEffect, useContext } from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {format} from "date-fns";

import * as net from "../../../../lib/net";
import Fr_Input from "../../../../lib/ui/fr_input";
import Fr_Select from "../../../../lib/ui/fr_select";
import * as utils from "../../../../assets/utils";

class Sell_Fsk extends React.Component {
  constructor(props, context) {
    super(props);

    this.pos = props.store.pos;
    this.state = {};
    this.state.today = new Date();
    var dts = format(this.state.today, "yyyy-MM-dd");
    this.state.dts = dts;

    this.state.sz_val = "";
      this.state.gnr = "001";
    //this.state.lro = props.lro;
    this.state.ynq = [
                {id: '0', text: 'NEJ'},
                {id: '1', text: 'JA'}
            ];

            this.state.boknr = "";
            this.state.gso = {};
            this.state.eko = {};
            this.state.cols = {};
            this.state.fso = {};
      this.state.fso.fsk00 = {};
      this.state.fso.fsk01 = {};
      this.state.tro = {};
      if(props.wnds) {                                          
        this.state.boknr = props.wnds.boknr;
        this.state.gso = props.wnds.gso;
        this.state.eko = props.wnds.eko;
        this.state.tro = props.wnds.tro;
        this.state.fso.fsk00.f0belopp = this.state.tro.belopp;
        this.state.fso.fsk00.f0saldo = this.state.tro.belopp;
         
        if(this.state.fso.fsk00.f0belopp.includes(".")) this.state.fso.fsk00.f0belopp = this.state.fso.fsk00.f0belopp.replace(/\./g,"");
        else this.state.fso.fsk00.f0belopp = this.state.fso.fsk00.f0belopp + "00";
        if(this.state.fso.fsk00.f0saldo.includes(".")) this.state.fso.fsk00.f0saldo = this.state.fso.fsk00.f0saldo.replace(/\./g,"");
        else this.state.fso.fsk00.f0saldo = this.state.fso.fsk00.f0saldo + "00";
     }
  }
  componentDidUpdate() {
  }
  componentWillUnmount() {
  }
  componentDidMount() {
      if(!this.props.wnds.fso) this.fsk_init();
  }

    fsk_init() {
        var udo = {};
        udo.e1bastyp = "";
        udo.e1typ = "";
        udo.e1blank = "";
        udo.e1kontonr = "";
        udo.e1text = "";
        udo.e1debcre = "";
        udo.e1moms = "";
        udo.e1pris = "";
        udo.e1mattyp = "";
        udo.e1kassabal = "";
        udo.e1cancelled = "";
        udo.e1paytrans = "";
        udo.e1man_rep = "";
        udo.e1no_avail = "";
        //alert(JSON.stringify(rso));
        this.setState({ udo: udo });
        return;
    }

    dlg_style() {
      var css = {};
      //css.width = window.innerWidth * 0.8;
      //css.height = window.innerHeight * 0.8;
      return css;
    }

    formchange (e) {
      const name = e.target.name;
      const value = e.target.value;
      var pbo = this.state.pbo;
      var na = name.split(".");
      pbo[na[0]][na[1]] = value;
      this.setState({pbo: pbo});
      //setState({[name]: value});
    }

    handleUserInput (e) {
      const name = e.target.name;
      const value = e.target.value;
      var user = this.state.user;
      user[name] = value;
      this.setState({user: user});
      //setState({[name]: value});
    }
    wnd_close = () => {
      if(this.props.close) {
          this.props.close(this.props.ctx, {});
      }
      else this.props.ctx.setState({ wnds: {} });
	};
    handleChange = (event, newValue) => {
        //alert(newValue);
        this.setState({ix: newValue});
      };
    toggle() {
      this.setState({modal: false});
	};

  submitHandler = event => {
    event.preventDefault();
    event.target.className += " was-validated";
  };

  changeHandler = event => {
    this.setState({ [event.target.name]: event.target.value });
  };

  val_save(id, val) {
      var fso = this.state.fso;
      var f0 = id.split(".")[0];
      var f1 = id.split(".")[1];
      fso[f0][f1] = val;
      this.setState({ fso: fso });
      return;
  }
  tb_style() {
      var css = {};
      css.height = window.innerHeight - 275;
      return css;
  }
  cssCols (cid) {
      var css = {};
      if(this.state.cols[cid]) css.width = this.state.cols[cid].toString() + "px";
      //if(cid == "c01") alert(JSON.stringify(this.state.cols[cid]));
      return css;
  }
  fsk_add() {
    var self = this;

    var prm = {};
    prm.req = "pms.fsk.fsk_add";
    prm.fso = this.state.fso;
    //alert(JSON.stringify(prm));
    //return;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));
        if(ret.ok == "000") {
            self.setState({wnd_ok: true });
            setTimeout(function(){
                self.setState({wnd_ok: false });
                self.sell_fsk();
                return;
            }, 1000);
        }
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
  fsk_del() {
    var self = this;
    var prm = {};
    prm.req = "pms.fsk.fsk_del";
    prm.fso = this.state.fso;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(ret));
        if(ret.ok == "000") {
            self.setState({wnd_ok: true });
            setTimeout(function(){
                self.setState({wnd_ok: false });
                if(self.props.wnds.cb) {
                    self.props.wnds.cb(self.props.ctx);
                }
                else self.props.ctx.setState({ wnds: {} });
                return;
            }, 1000);
        }
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }
  sell_fsk() {
    var self = this;

    var tro = this.state.tro;
    var tkn = "+";
    if(tro.pris.includes("-")) {
        tro.pris = tro.pris.replace(/\-/g,"");
        tkn = "-";
    }
    //if(tro.tkn.includes("-")) tkn = "-";

    //if(tro.pris.includes(".")) tro.pris = tro.pris.replace(".", "");
    if(tro.pris.includes(".")) tro.pris = tro.pris.replace(/\./g,"");
    else tro.pris = tro.pris + "00";

    var prm = {};
    //prm.req = "pms.sell.charge_payment";
    prm.req = "pms.sell.charge_tro";
    prm.boknr = this.state.boknr;
    prm.gsb00 = this.state.gso;
    prm.eko = this.state.eko;
    prm.bastyp = "P";
    prm.typ = "P";
    prm.trkod = tro.id;
    prm.text = tro.text;
    prm.antal = tro.antal;
    prm.pris = tro.pris;
    prm.tkn = tkn;
    prm.moms = tro.moms;
    prm.datum = this.state.dts;

    net.sio_req(prm)
    .then(function(ret){
        //alert(JSON.stringify(tro));

      if(self.props.wnds.cb) {
        var rsp = {};
        rsp.ok = "000";
          self.props.wnds.cb(self.props.ctx, rsp);
      }
      else self.props.ctx.setState({ wnds: {} });
    })
    .catch(function(e){
        var txt = JSON.stringify(e);
    });
  }

    sz_keydown (e) {
        //e.preventDefault();
        const key = e.key;
        const keyCode = e.keyCode;

        if(keyCode == 13) {
            this.plu_sz();
        };
        if(keyCode == 27) {
            this.setState({sz_val: ""});
        };
    }
    sz_change (e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({sz_val: value});
        //setState({[name]: value});
    }

  render() {
    //if(!this.props.show) return "";
    var title = this.props.title;
    if(!title) title = "UDID";
    //if(props.kro) alert(props.kro.krr00.kid);

	var html =
        <div className="mx_base">
        <div className="m2_backdrop" />
        <div className="m2_dlg mx_70 flex-col" style={ this.dlg_style() } >
        <div className="mx_top flex-row">

            <div className="txt-22">
                <div>SÄLJ FÖRSKOTT: { utils.toPris(this.state.tro.belopp) }</div>
            </div>
            <div className="flex"></div>
            <div>UPPDATERA</div>
        </div>
            <div className="divider_orange"></div>

            <form className="cdi_f03">
                <div className="flex-row hide">
                    <Fr_Input label="Fsk nr" className="text-left w250" text={ this.state.fso.fsk00.f0id } getValue={(e)=> this.val_save("fsk00.f0id", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input label="Text" className="text-left w350" text={ this.state.fso.fsk00.f0text } getValue={(e)=> this.val_save("fsk00.f0text", e) } />
                </div>
                <div className="flex-row hide">
                    <Fr_Input label="Skapat" className="text-left w150" text={ this.state.fso.fsk00.f0datum } getValue={(e)=> this.val_save("fsk00.f0datum", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input readonly label="Belopp" className="text-right w250" text={utils.toPris( this.state.fso.fsk00.f0belopp )} getValue={(e)=> this.val_save("fsk00.f0belopp", e) } />
                </div>
                <div className="flex-row">
                    <Fr_Input readonly label="Saldo" className="text-right w250" text={utils.toPris( this.state.fso.fsk00.f0saldo )} getValue={(e)=> this.val_save("fsk00.f0saldo", e) } />
                </div>
            </form>

            <div className="mx_section">

                <form className="cdi_f03">
                <div className="divider_green"></div>
                <div className="flex-row">
                    <Fr_Input label="Skapad av" className="text-left w250" text={this.state.fso.fsk01.f1issuedby} getValue={(e)=> this.val_save("fsk01.f1issuedby", e) } />
                </div>
                <div className="flex flex-column" style={{padding: "0px 5px"}}>
                    <span className="header">Anmärkning</span>
                    <textarea label="Anm" className="form-control" maxLength="512" rows="5" value={this.state.fso.fsk01.f1anm} onChange={(e) => this.val_save("fsk01.f1anm", e.target.value)} ></textarea>
                </div>
                </form>

            </div>
            <div className="flex"></div>

        <div className="mx_foot flex-row flex-space-between">
            <button className="btn btn-hw-red w250" onClick={() => this.wnd_close() } >
                STÄNG
            </button>
            <div className="flex-row">
            <button className="btn btn-hw-green w250" onClick={() => this.fsk_add() } >
                SPARA
            </button>
            </div>
        </div>
      </div>

      </div>
	;
	return html;
  };
}

export default Sell_Fsk;